export enum OpoAddressType {
    Primary = 1,
    Billing = 2,
    StrongBox = 3
}

export interface IOpoAddress {
    id: number,
    typeId: OpoAddressType,
    typeName: string,
    label: string,
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
    city: string,
    stateId: number,
    stateAbbreviation: string,
    postalCode: string,
    note: string,
    firstName: string,
    lastName: string,
    shipToPhoneNumber: string
}

export interface IOpoAddressRequest {
    typeId: OpoAddressType,
    label: string,
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
    city: string,
    stateId: number,
    postalCode: string,
    note: string,
    firstName: string,
    lastName: string,
    shipToPhoneNumber: string
}

export interface IOpoAddressOption {
    id: number,
    description: string,
    abbreviation?: string
}

export interface IOpoAddressesData {
    addresses: IOpoAddress[],
    addressTypes: IOpoAddressOption[],
    states: IOpoAddressOption[],
    canManage: boolean
}
